import { z } from 'zod';
import { ownerTypeSchema } from './enum.schemas.js';
import { uuidSchema } from './id.schemas.js';
/**
 * Inspections, valuations, cost items, approvals and activity belong to *either* an estimate or a
 * vehicle (plan §2.3). One address type keeps a single set of contracts serving both owners, and the
 * purchase copies the children from one to the other without a second schema.
 */
export const ownerSchema = z.object({
    type: ownerTypeSchema,
    id: uuidSchema,
});
//# sourceMappingURL=owner.schemas.js.map